import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.Find.IRequest;
type Response = Api.Core.DealerGroup.Find.IResponse;
type Headers = Api.Core.DealerGroup.Find.IHeaders;
const url = '/api/DealerManagement/DealerGroup/:id';
export default async function dealerGroupFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
